import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a03hpip0sg: FaireBrandEntity = {
  token: "b_a03hpip0sg",
  type: "brand",
  name: "WTHN",
  avatarUrl:
    "https://cdn.faire.com/fastly/300f1773b69bbf36da21076e92d5e6477b7b284c394109587d31a9d635669fe5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9f954728c313e3ae96f8196c9e156e605760c624f5068f0ea053240831f1d286.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/300f1773b69bbf36da21076e92d5e6477b7b284c394109587d31a9d635669fe5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9f954728c313e3ae96f8196c9e156e605760c624f5068f0ea053240831f1d286.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "Ancient Healing, Modern Wellness.  Organic herbal supplements, wellness accessories, and ancient beauty tools.  Come visit our acupuncture + cupping studios in NYC!  \n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:10.302Z",
    importedBy: "entity-db-cli",
  },
};
